import { Slider } from "../../ui/slider";
import { IoCloseSharp } from "react-icons/io5";
import { FaWallet } from "react-icons/fa";
import { useEffect, useState } from "react";
import styles from './A23LobbyBuyIn.module.css';
import { RUPEE_SYMBOL } from "@/Poker/data/Constants";
import { Drawer, DrawerClose, DrawerContent } from "../../ui/drawer";
import usePlayerBalance from "@/src/hooks/data/usePlayerBalance";
import useLobbyBuyIn from "@/src/hooks/data/useLobbyBuyIn";
import useCreateGame from "@/src/hooks/utils/useCreateGame";
import { useDispatch } from "react-redux";
import { closeBuyInPopupInLobby } from "@/Poker/redux/slices/lobbySlice";
import { returnGameTypeText } from "@/Common/utils/PokerUtils";
import InsufficientBalance from "../../InsufficientBalance/InsufficientBalance";
import useTableSettings from "@/src/hooks/data/useTableSettings";
import useLobbyConnectionStatus from "@/src/hooks/data/useLobbyConnectionStatus";

export default function A23LobbyBuyIn() {
    const dispatch = useDispatch();
    const { totalBalance } = usePlayerBalance();
    const { visible, gameDefinition } = useLobbyBuyIn();
    const { initiateCreateTable } = useCreateGame();
    const { smallBlind, bigBlind, maxbuyInAmount, minBuyInAmount, tableName, gameType } = gameDefinition;
    const [entryAmount, setEntryAmount] = useState(minBuyInAmount);
    const { tableSettings } = useTableSettings();
    const [triggerAutoBuyIn, setTriggerAutoBuyIn] = useState(false);
    const insufficientBalance = totalBalance < minBuyInAmount;
    const { connected } = useLobbyConnectionStatus();

    const handleOutsideClick = () => {
        dispatch(closeBuyInPopupInLobby({ buyInAmount: null }));
    }

    const handleCloseMark = () => {
        dispatch(closeBuyInPopupInLobby({ buyInAmount: null }));
    }

    const handleBuyInButton = () => {
        dispatch(closeBuyInPopupInLobby({ buyInAmount: entryAmount }));
        initiateCreateTable(gameDefinition);
    }

    useEffect(() => {
        setEntryAmount(minBuyInAmount);
    }, [minBuyInAmount])

    useEffect(() => {
        if (tableSettings.autoBuyIn.enabled && visible && !insufficientBalance) {
            setTriggerAutoBuyIn(true);
            let entryAmount = Math.min(totalBalance * (tableSettings.autoBuyIn.percentage / 100), minBuyInAmount);
            dispatch(closeBuyInPopupInLobby({ buyInAmount: entryAmount }));
            initiateCreateTable(gameDefinition);
        } else {
            setTriggerAutoBuyIn(false);
            // setEntryAmount(minBuyInAmount)
        }
    }, [tableSettings.autoBuyIn.enabled, visible, minBuyInAmount, insufficientBalance, totalBalance, gameDefinition, initiateCreateTable, dispatch, tableSettings.autoBuyIn.percentage])

    if (!visible) {
        return null;
    }

    return (
        <Drawer dismissible={false} open={visible && !triggerAutoBuyIn && connected}>
            <DrawerContent draggable={false} showCloseButton={false} onInteractOutside={handleOutsideClick} side="bottom" className={styles.container}>
                {/* Header with centered title and close button */}
                {
                    insufficientBalance
                        ?
                        <InsufficientBalance handleCloseMark={handleCloseMark} totalBalance={totalBalance} minBuyInAmount={minBuyInAmount} />
                        :
                        <>
                            <div className={styles.header}>
                                <div className={styles.headerSpacer}></div>
                                <h2 className={styles.title}>Buy In</h2>
                                <DrawerClose onClick={handleCloseMark} className={styles.closeButton}>
                                    <IoCloseSharp className={styles.closeIcon} />
                                </DrawerClose>
                            </div>

                            <div className={styles.buyInContent}>

                                {/* First row: Table name with game type badge and wallet balance header */}
                                <div className={styles.detailsSection}>
                                    <div className={styles.detailRow}>
                                        <div className={styles.leftContent}>
                                            <span className={styles.tableName}>{tableName}</span>
                                            <span className={styles.gameTypeBadge}>{returnGameTypeText(gameType)}</span>
                                        </div>
                                        <div className={styles.rightContent}>
                                            <span className={styles.walletHeader}>Wallet Balance</span>
                                        </div>
                                    </div>

                                    {/* Second row: Blinds and wallet balance with icon */}
                                    <div className={styles.detailRow}>
                                        <div className={styles.leftContent}>
                                            <span className={styles.detailLabel}>Blinds:</span>
                                            <span className={styles.detailValue}>{smallBlind}/{bigBlind}</span>
                                        </div>
                                        <div className={styles.rightContent}>
                                            <div className={styles.walletBalance}>
                                                <FaWallet className={styles.walletIcon} />
                                                <span className={styles.balanceAmount}>{RUPEE_SYMBOL + totalBalance}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.buyInBottomRow}>
                                    {/* Third row: Entry Amount */}
                                    <div className={styles.detailRow}>
                                        <div className={styles.leftContent}>
                                            <span className={styles.entryAmountLabel}>Entry Amount :</span>
                                        </div>
                                        <div className={styles.entryAmountContainer}>
                                            <span className={styles.entryAmountValue}>{RUPEE_SYMBOL + entryAmount}</span>
                                        </div>
                                    </div>

                                    {/* Slider */}
                                    <div className={styles.sliderContainer}>
                                        <Slider
                                            value={[entryAmount]}
                                            onValueChange={(value) => {
                                                setEntryAmount(value[0])
                                            }}
                                            min={minBuyInAmount}
                                            max={totalBalance < maxbuyInAmount ? totalBalance : maxbuyInAmount}
                                        />
                                        <div className={styles.sliderLabelContainer}>
                                            <span className={styles.sliderLabel}>Min. {RUPEE_SYMBOL + minBuyInAmount}</span>
                                            <span className={styles.sliderLabel}>Max. {RUPEE_SYMBOL + (totalBalance < maxbuyInAmount ? totalBalance : maxbuyInAmount)}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.buttonContainer}>
                                    {/* Buy In Button */}
                                    <button className={styles.buyInButton} onClick={handleBuyInButton}>
                                        Buy In
                                    </button>
                                </div>
                            </div>
                        </>
                }
            </DrawerContent>
        </Drawer >
    )
}
